import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh.json'
import en from './en.json'
import th from './th.json'
import tw from './tw.json'

// 框架自带语言更改
import locale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import thLocale from 'element-ui/lib/locale/lang/th'
import {getSession, getStore, setSession, setStore} from "../utils";

Vue.use(VueI18n)

// 默认语种为中文
let DEFAULT_LANG = 'zh_CN'
const LOCAL_KEY = 'localeLanguage'

if (process.env.ENV_CONFIG =='devOverseas' || process.env.ENV_CONFIG =='prodOverseas' || process.env.ENV_CONFIG == 'thdev' || process.env.ENV_CONFIG == 'thuat' || process.env.ENV_CONFIG == 'thprod'){
  DEFAULT_LANG = 'th_TH'
}

const locales = {
  zh_CN: Object.assign(zh, zhLocale),//中文简体
  en_US: Object.assign(en, enLocale),//英文
  zh_TW: Object.assign(tw, twLocale),//中文繁体
  th_TH: Object.assign(th, thLocale)//泰文
}

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
  silentFallbackWarn: true
})

// console.log(i18n, 'i18n')

// 官网兼容 vue-i18n@6.x
locale.i18n((key, value) => i18n.t(key, value))  //为了实现element插件的多语言切换

export const setup = lang => {
  if (lang === undefined) {
    lang = getStore(LOCAL_KEY)
    if (locales[lang] === undefined) {
      lang = DEFAULT_LANG
    }
  }
  setStore(LOCAL_KEY, lang);

  Object.keys(locales).forEach(lang => {
    document.body.classList.remove(`lang-${lang}`)
  })
  document.body.classList.add(`lang-${lang}`)
  document.body.setAttribute('lang', lang)

  Vue.config.lang = lang
  i18n.locale = lang
}

setup()
// 在vue实例外，调用 i18n，可以将i18n挂到window下，避免出现 i18n is not defined
window.i18n = i18n
export default i18n



// WEBPACK FOOTER //
// ./src/locales/index.js